var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints, AutoGroupFilterList, CommonConstant, GenderEnum } from '../../app.constants';
import { Influencer } from '../../../models/influencer';
import { Observable } from 'rxjs/Observable';
import { BackendHttpService } from '../../core/backend-http.service';
import { ValidationError } from '../../../models/ErrorTemplate';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceDataService } from '../reference-data/reference-data.service';
import { Router } from '@angular/router';
import { AutoGroupComparisonConfig, AutoGroupFilterConfig, AutoGroupFilterEnum, AutoGroupSourceEnum, GroupVersion, NewInfluencerGroup } from '../../../models/auto-group/auto-group-setting';
export var GroupTypeEnum;
(function (GroupTypeEnum) {
    GroupTypeEnum[GroupTypeEnum["PREFERRED"] = 1] = "PREFERRED";
    GroupTypeEnum[GroupTypeEnum["PROJECT"] = 2] = "PROJECT";
    GroupTypeEnum[GroupTypeEnum["TOPIC"] = 3] = "TOPIC";
    GroupTypeEnum[GroupTypeEnum["INDUSTRIES"] = 4] = "INDUSTRIES";
    GroupTypeEnum[GroupTypeEnum["CAMPAIGNS"] = 5] = "CAMPAIGNS";
})(GroupTypeEnum || (GroupTypeEnum = {}));
export var GroupConditionTypeEnum;
(function (GroupConditionTypeEnum) {
    GroupConditionTypeEnum["MENTION"] = "keyword";
    GroupConditionTypeEnum["COUNTRY"] = "country";
    GroupConditionTypeEnum["REACH_MONTHLY"] = "reach";
    GroupConditionTypeEnum["ENGAGEMENT_MONTHLY"] = "engagement";
    GroupConditionTypeEnum["IMPACT_MONTHLY"] = "impact";
    GroupConditionTypeEnum["AUDIENCE_AGE"] = "audience_age";
    GroupConditionTypeEnum["AUDIENCE_GENDER"] = "audience_gender";
    GroupConditionTypeEnum["AUDIENCE_COUNTRY"] = "audience_country";
    GroupConditionTypeEnum["INFLUENCER_GENDER"] = "gender";
})(GroupConditionTypeEnum || (GroupConditionTypeEnum = {}));
var GroupService = /** @class */ (function (_super) {
    __extends(GroupService, _super);
    function GroupService(router, translate, referenceData) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.referenceData = referenceData;
        return _this;
    }
    GroupService.prototype.getInfluencerGroup = function (influencer_group_id) {
        var _this = this;
        return this.get(apiEndpoints.getInfluencerGroupDetails, { influencer_group_id: influencer_group_id })
            .map(function (res) {
            if (!res || !res.data) {
                return null;
            }
            if (res.data.version === GroupVersion.V2) {
                return _this.createNewGroup(influencer_group_id, res.data.name, res.data.description, res.data.sources, res.data.filters);
            }
            else if (Array.isArray(res.data.condition_list_object) && res.data.condition_list_object.length === 0) {
                return _this.createNewGroup(influencer_group_id, res.data.influencer_group_name, res.data.influencer_group_description, null, null);
            }
            else {
                return _this.normalizeInfluencerGroupResponse(res.data, influencer_group_id);
            }
        });
    };
    GroupService.prototype.createNewGroup = function (id, name, description, sources, filters) {
        var influencerGroup = new NewInfluencerGroup();
        influencerGroup.id = id;
        influencerGroup.name = name;
        influencerGroup.description = description;
        influencerGroup.type = CommonConstant.NEW_AUTO_GROUP_TYPE;
        influencerGroup.sources = sources ? sources : [];
        influencerGroup.filters = filters ? this.denormalizeAutoGroupFilter(filters) : [];
        return influencerGroup;
    };
    GroupService.prototype.normalizeInfluencerGroupResponse = function (influencerGroupResponse, influencerGroupId) {
        var influencer_group_type_id;
        if (influencerGroupResponse.influencer_group_type_values.length > 0) {
            // on Redesign, only suppose single seletion for group type value
            var firstGroupTypeValue = influencerGroupResponse.influencer_group_type_values[0];
            influencerGroupResponse.influencer_group_type_values = [firstGroupTypeValue];
            influencer_group_type_id = Number(firstGroupTypeValue.id);
        }
        influencerGroupResponse.influencer_group_type_id = influencer_group_type_id;
        influencerGroupResponse.influencer_group_id = influencerGroupId;
        influencerGroupResponse.condition_list_object = this.denormalizeGroupConditionList(influencerGroupResponse.condition_list_object);
        return influencerGroupResponse;
    };
    GroupService.prototype.denormalizeGroupConditionList = function (conditionList) {
        var _this = this;
        return conditionList.map(function (c) {
            if (c.selectedConditionType.indexOf(GroupConditionTypeEnum.AUDIENCE_AGE) >= 0
                || c.selectedConditionType.indexOf(GroupConditionTypeEnum.AUDIENCE_GENDER) >= 0
                || c.selectedConditionType.indexOf(GroupConditionTypeEnum.AUDIENCE_COUNTRY) >= 0) {
                var conditionTypeAndValue = _this.extractConditionTypeAndValue(c.selectedConditionType, c.selectedConditionComparisionValue);
                return {
                    index: c.index,
                    selectedConditionComparision: c.selectedConditionComparision,
                    selectedConditionOperator: c.selectedConditionOperator,
                    minPercent: conditionTypeAndValue.percent.toString(),
                    selectedConditionComparisionValue: conditionTypeAndValue.value,
                    selectedConditionType: c.selectedConditionType
                };
            }
            else if (c.selectedConditionType.indexOf(GroupConditionTypeEnum.COUNTRY) >= 0) {
                var country = _this.referenceData.countries.find(function (co) { return co.name === c.selectedConditionComparisionValue; });
                return Object.assign({}, c, {
                    selectedConditionComparisionValue: country ? country.id.toString() : 0
                });
            }
            else {
                return c;
            }
        });
    };
    GroupService.prototype.normalizeGroupConditionList = function (conditionList) {
        var _this = this;
        return conditionList.map(function (c) {
            if (_this.isAudienceFilter(c.selectedConditionType)) {
                return {
                    index: c.index,
                    selectedConditionComparision: c.selectedConditionComparision,
                    selectedConditionType: c.selectedConditionType,
                    selectedConditionComparisionValue: c.selectedConditionComparisionValue + "_" + Number(c.minPercent) / 100,
                    selectedConditionOperator: c.selectedConditionOperator
                };
            }
            else {
                return c;
            }
        });
    };
    GroupService.prototype.isAudienceFilter = function (conditionType) {
        return conditionType === GroupConditionTypeEnum.AUDIENCE_GENDER
            || conditionType === GroupConditionTypeEnum.AUDIENCE_AGE
            || conditionType === GroupConditionTypeEnum.AUDIENCE_COUNTRY;
    };
    GroupService.prototype.extractConditionTypeAndValue = function (conditionType, conditionValue) {
        var values = conditionValue.split('_');
        if (conditionType === GroupConditionTypeEnum.AUDIENCE_COUNTRY) {
            var country = this.referenceData.countries.find(function (c) { return c.code === values[0]; });
            return {
                value: country ? country.id.toString() : null,
                percent: Number(values[1]) * 100
            };
        }
        else {
            return {
                value: values[0],
                percent: Number(values[1]) * 100
            };
        }
    };
    GroupService.prototype.updateInfluencerGroup = function (influencerGroup) {
        return this.post(apiEndpoints.updateInfluencerGroup, influencerGroup);
    };
    /**
     * update Auto Group Setting V2
     */
    GroupService.prototype.updateInfluencerGroupV2 = function (influencerGroup, companyId) {
        var formattedFilters = this.normalizeAutoGroupFilter(influencerGroup.filters);
        var formattedSources = influencerGroup.sources.filter(function (s) { return s.type !== AutoGroupSourceEnum.BRANDED_SIGNUP; });
        var groupData = Object.assign({}, influencerGroup, {
            companyId: companyId,
            filters: formattedFilters,
            sources: formattedSources
        });
        delete groupData.version;
        return this.post(apiEndpoints.updateInfluencerGroupV2, groupData);
    };
    GroupService.prototype.normalizeAutoGroupFilter = function (filters) {
        var _this = this;
        var formattedFilters = [];
        filters.forEach(function (f) {
            var filterConfig = AutoGroupFilterConfig[f.type];
            if (filterConfig.multiple && Array.isArray(f.secondValue)) {
                var multipleFilters = f.secondValue.map(function (s) { return ({
                    index: f.index,
                    type: f.type,
                    comparison: AutoGroupComparisonConfig[f.comparison].operator,
                    value: s
                }); });
                formattedFilters.push.apply(formattedFilters, multipleFilters);
            }
            else if (filterConfig.numOfCol === AutoGroupFilterList.multipleValueColumn) {
                var formattedSecondValue = _this.getSecondFilterValue(f.type, f.secondValue);
                var combinedValue = formattedSecondValue + "_" + f.firstValue;
                formattedFilters.push({
                    index: f.index,
                    type: f.type,
                    comparison: AutoGroupComparisonConfig[f.comparison].operator,
                    value: combinedValue
                });
            }
            else {
                formattedFilters.push({
                    index: f.index,
                    type: f.type,
                    comparison: AutoGroupComparisonConfig[f.comparison].operator,
                    value: f.secondValue
                });
            }
        });
        formattedFilters.sort(function (f1, f2) { return f1.index - f2.index; });
        return formattedFilters;
    };
    GroupService.prototype.denormalizeAutoGroupFilter = function (filters) {
        var _this = this;
        var formattedFilters = [];
        filters.forEach(function (f) {
            var isExisted = formattedFilters.findIndex(function (fi) { return fi.type === f.type && fi.comparison === f.comparison; }) >= 0;
            if (isExisted) {
                return;
            }
            var filterConfig = AutoGroupFilterConfig[f.type];
            if (filterConfig.multiple) {
                var filterValues = filters.filter(function (fi) { return fi.type === f.type; }).map(function (filter) { return Number(filter.value); });
                var groupingFilter = {
                    index: f.index,
                    type: f.type,
                    comparison: f.comparison,
                    firstValue: null,
                    secondValue: filterValues
                };
                formattedFilters.push(groupingFilter);
            }
            else if (filterConfig.numOfCol === AutoGroupFilterList.multipleValueColumn) {
                var normalizedFilter = {
                    index: f.index,
                    type: f.type,
                    comparison: f.comparison,
                    firstValue: Number(_this.denormalizeFirstValue(f.value)),
                    secondValue: _this.denormalizeSecondValue(f.type, f.value)
                };
                formattedFilters.push(normalizedFilter);
            }
            else {
                formattedFilters.push({
                    index: f.index,
                    type: f.type,
                    comparison: f.comparison,
                    firstValue: null,
                    secondValue: Number(f.value)
                });
            }
        });
        var result = formattedFilters.map(function (ff) { return Object.assign({}, ff, {
            comparison: _this.getComparisonByOperator(ff.comparison, ff.type)
        }); });
        result.sort(function (f1, f2) { return f1.index - f2.index; });
        return result;
    };
    GroupService.prototype.getSecondFilterValue = function (filterType, secondValue) {
        var selectedValue = null;
        switch (filterType) {
            case AutoGroupFilterEnum.COUNTRY:
            case AutoGroupFilterEnum.AUDIENCE_COUNTRY:
                var country = this.referenceData.countries.find(function (c) { return c.id === secondValue; });
                if (country) {
                    selectedValue = country.code;
                }
                break;
            case AutoGroupFilterEnum.INFLUENCER_GENDER:
            case AutoGroupFilterEnum.AUDIENCE_GENDER:
                if (secondValue === GenderEnum.MALE) {
                    selectedValue = AutoGroupFilterList.genders.male;
                }
                else if (secondValue === GenderEnum.FEMALE) {
                    selectedValue = AutoGroupFilterList.genders.female;
                }
                else {
                    selectedValue = AutoGroupFilterList.genders.online_media;
                }
                break;
            case AutoGroupFilterEnum.AUDIENCE_AGE:
                var ageRange = AutoGroupFilterList.audienceAgeList.find(function (age) { return age.id === secondValue; });
                if (ageRange) {
                    selectedValue = ageRange.formatted;
                }
                break;
            case AutoGroupFilterEnum.AVG_INTERACTION_PER_POST:
            case AutoGroupFilterEnum.AVG_ENGAGEMENT_PER_POST:
            case AutoGroupFilterEnum.AVG_REACH_PER_POST:
            case AutoGroupFilterEnum.FOLLOWERS:
            case AutoGroupFilterEnum.PLATFORM:
                selectedValue = secondValue;
                break;
        }
        return selectedValue;
    };
    GroupService.prototype.denormalizeFirstValue = function (value) {
        var valueArr = value.split('_');
        if (valueArr.length === 2) {
            return valueArr[1];
        }
        else {
            return valueArr[valueArr.length - 1];
        }
    };
    GroupService.prototype.denormalizeSecondValue = function (filterType, value) {
        var selectedValue = null;
        switch (filterType) {
            case AutoGroupFilterEnum.COUNTRY:
            case AutoGroupFilterEnum.AUDIENCE_COUNTRY:
                var country = this.referenceData.countries.find(function (c) { return c.code === value.split('_')[0]; });
                if (country) {
                    selectedValue = country.id;
                }
                break;
            case AutoGroupFilterEnum.INFLUENCER_GENDER:
            case AutoGroupFilterEnum.AUDIENCE_GENDER:
                if (value.startsWith(AutoGroupFilterList.genders.male)) {
                    selectedValue = GenderEnum.MALE;
                }
                else if (value.startsWith(AutoGroupFilterList.genders.female)) {
                    selectedValue = GenderEnum.FEMALE;
                }
                else {
                    selectedValue = GenderEnum.ONLINE_MEDIA;
                }
                break;
            case AutoGroupFilterEnum.AUDIENCE_AGE:
                var ageRange = AutoGroupFilterList.audienceAgeList.find(function (age) { return age.formatted === value.split('_')[0]; });
                if (ageRange) {
                    selectedValue = ageRange.id;
                }
                break;
            case AutoGroupFilterEnum.AVG_INTERACTION_PER_POST:
            case AutoGroupFilterEnum.AVG_ENGAGEMENT_PER_POST:
            case AutoGroupFilterEnum.AVG_REACH_PER_POST:
            case AutoGroupFilterEnum.FOLLOWERS:
            case AutoGroupFilterEnum.PLATFORM:
                selectedValue = value;
                break;
        }
        return selectedValue;
    };
    GroupService.prototype.getComparisonByOperator = function (operator, filterType) {
        var filterConfig = AutoGroupFilterConfig[filterType];
        if (!filterConfig) {
            return null;
        }
        var comparison = filterConfig.comparison.find(function (comp) { return AutoGroupComparisonConfig[comp].operator === operator; });
        return comparison ? comparison : null;
    };
    /**
     * This method used to validate the condition list of Group Setting
     * There are some rules as defined:
     * Condition Type: MENTION -> (multiple comparision)
     * Condition Type: COUNTRY -> (multiple comparision and operator. However, every comparision and operator must be the same)
     * Condition Type: IMPACT_MONTHLY, ENGAGEMENT_MONTHLY, REACH_MONTHLY -> Single comparision and multiple operator
     * @param {GroupCondition[]} conditionList
     * @returns {boolean}
     */
    GroupService.prototype.validateConditions = function (conditionList) {
        var _this = this;
        // define Error result
        var errors = [];
        conditionList.forEach(function (condition, index) {
            switch (condition.selectedConditionType) {
                case GroupConditionTypeEnum.COUNTRY:
                    var countryErrors = _this.validateCountryCondition(index, conditionList);
                    errors.push.apply(errors, countryErrors);
                    break;
                case GroupConditionTypeEnum.IMPACT_MONTHLY:
                case GroupConditionTypeEnum.ENGAGEMENT_MONTHLY:
                case GroupConditionTypeEnum.REACH_MONTHLY:
                    var singleConditionErrors = _this.validateSingeSelection(index, conditionList);
                    errors.push.apply(errors, singleConditionErrors);
                    break;
            }
        });
        return errors;
    };
    GroupService.prototype.validateCountryCondition = function (index, conditionList) {
        // define Error result
        var errors = [];
        var countryConditions = conditionList.filter(function (condition) { return condition.selectedConditionType === GroupConditionTypeEnum.COUNTRY; });
        if (countryConditions.length <= 1) {
            return errors;
        }
        var firstConditionOperator = countryConditions[0];
        var haveDifferenceCondition = countryConditions.filter(function (con) {
            return con.index !== firstConditionOperator.index
                && con.selectedConditionOperator !== firstConditionOperator.selectedConditionOperator;
        }).length > 0;
        if (haveDifferenceCondition) {
            errors.push(new ValidationError("conditionListObject[" + index + "].selectedConditionType", this.translate.instant('group_details.error_operator_country')));
            return errors;
        }
        var haveDifferenceComparision = countryConditions.filter(function (con) {
            return con.index !== firstConditionOperator.index && con.selectedConditionComparision
                && con.selectedConditionComparision !== firstConditionOperator.selectedConditionComparision;
        }).length > 0;
        if (haveDifferenceComparision) {
            errors.push(new ValidationError("conditionListObject[" + index + "].selectedConditionType", this.translate.instant('group_details.error_comparision_country_difference')));
            return errors;
        }
        return errors;
    };
    GroupService.prototype.validateSingeSelection = function (index, conditionList) {
        // define Error result
        var errors = [];
        var reachConditions = conditionList.filter(function (condition) {
            return condition.selectedConditionType === GroupConditionTypeEnum.REACH_MONTHLY;
        });
        if (reachConditions.length > 1) {
            errors.push(new ValidationError("conditionListObject[" + index + "].selectedConditionType", this.translate.instant('group_details.error_duplicate_condition_type')));
            return errors;
        }
        var engagementConditions = conditionList.filter(function (condition) {
            return condition.selectedConditionType === GroupConditionTypeEnum.ENGAGEMENT_MONTHLY;
        });
        if (engagementConditions.length > 1) {
            errors.push(new ValidationError("conditionListObject[" + index + "].selectedConditionType", this.translate.instant('group_details.error_duplicate_condition_type')));
            return errors;
        }
        var impactConditions = conditionList.filter(function (condition) {
            return condition.selectedConditionType === GroupConditionTypeEnum.IMPACT_MONTHLY;
        });
        if (impactConditions.length > 1) {
            errors.push(new ValidationError("conditionListObject[" + index + "].selectedConditionType", this.translate.instant('group_details.error_duplicate_condition_type')));
            return errors;
        }
        return errors;
    };
    GroupService.prototype.isConditionReachMonthly = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.REACH_MONTHLY;
    };
    GroupService.prototype.isConditionEngagementMonthly = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.ENGAGEMENT_MONTHLY;
    };
    GroupService.prototype.isConditionImpactMonthly = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.IMPACT_MONTHLY;
    };
    GroupService.prototype.isConditionMention = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.MENTION;
    };
    GroupService.prototype.isConditionCountry = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.COUNTRY || conditionValue === GroupConditionTypeEnum.AUDIENCE_COUNTRY;
    };
    GroupService.prototype.isAgeCondition = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.AUDIENCE_AGE;
    };
    GroupService.prototype.isAudienceGenderCondition = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.AUDIENCE_GENDER;
    };
    GroupService.prototype.isInfluencerGenderCondition = function (conditionValue) {
        return conditionValue === GroupConditionTypeEnum.INFLUENCER_GENDER;
    };
    GroupService.prototype.isSingleComparision = function (conditionType) {
        return conditionType === GroupConditionTypeEnum.IMPACT_MONTHLY || conditionType === GroupConditionTypeEnum.ENGAGEMENT_MONTHLY
            || conditionType === GroupConditionTypeEnum.REACH_MONTHLY;
    };
    GroupService.prototype.loadInfluencerListOfGroup = function (groupSearch) {
        return this.post(apiEndpoints.getInfluencerGroupInfluencerKPI, groupSearch);
    };
    GroupService.prototype.getInfluencerListByGroupId = function (groupSearch, influencerGroupId) {
        return this.get(apiEndpoints.getInfluencerListByGroupId.replace(':groupId', influencerGroupId), groupSearch);
    };
    /**
     * this method use to load the influencer suggestion list by a query
     * user for AutoComplete component
     * @param {string} term
     * @returns {Observable<any>}
     */
    GroupService.prototype.loadInfluencerSuggestion = function (term, scrollId) {
        var params = {
            searchString: term,
        };
        if (scrollId) {
            params = Object.assign({}, params, { scrollId: scrollId });
        }
        return this.get(apiEndpoints.searchInfluencer, params)
            .map(function (res) { return res.data; })
            .catch(function (err) { return Observable.of([]); });
    };
    /**
     * this method use to get the details of Influencer by id
     * @param {number} influencerId
     * @returns {Observable<Influencer>}
     */
    GroupService.prototype.getInfluencerDetails = function (influencerId) {
        return this.get(apiEndpoints.getInfluencerById + influencerId).map(function (res) {
            if (!res || !res.data) {
                return null;
            }
            var influencer = new Influencer();
            influencer.id = res.data.id;
            influencer.influencer_name = res.data.name;
            influencer.country_code = res.data.country.code;
            influencer.influencerChannels = res.data.influencerChannels;
            return influencer;
        });
    };
    /**
     * this method use to add an influencer to group
     * @param influencerGroupAdding
     * @returns {Observable<any>}
     */
    GroupService.prototype.addInfluencerToGroup = function (influencerGroupAdding) {
        return this.post(apiEndpoints.saveInfluencerManualAddedToInfluencerGroup, influencerGroupAdding);
    };
    /**
     * add a list of Influencer to specific group as pending
     * @param influencerGroupAdding
     * @returns {Observable<any>}
     */
    GroupService.prototype.addInfluencerToGroupAsPending = function (influencerGroupAdding) {
        return this.post(apiEndpoints.addPendingInfluencerToGroup.replace(':groupId', influencerGroupAdding.influencer_group_id.toString()), {
            influencerList: influencerGroupAdding.influencerList,
            group_id: influencerGroupAdding.influencer_group_id,
            reviewerList: influencerGroupAdding.reviewList
        });
    };
    /**
     * this method use to move multiple influencers to a group
     * @param influencerGroupAdding
     * @returns {Observable<any>}
     */
    GroupService.prototype.moveInfluencerToGroup = function (influencerGroupId, influencers, newGroupId, companyId) {
        return this.put(apiEndpoints.moveInfluencersToAnotherGroup.replace(':groupId', influencerGroupId), { influencers: influencers, newGroupId: newGroupId, companyId: companyId });
    };
    /**
     * this method use to delete one influencer in a group
     * @param {number} influencerId
     * @param {number} influencerGroupId
     * @param {number} companyId
     * @returns {Observable<any>}
     */
    GroupService.prototype.deleteInfluencerOfGroup = function (influencerIds, influencerGroupId, companyId) {
        var influencerDeleteData = {
            companyId: companyId,
            influencers: influencerIds,
        };
        return this.put(apiEndpoints.removeInfluencers.replace(':groupId', influencerGroupId), influencerDeleteData);
    };
    /**
     * Approve a pending influencer in group
     * @param {number} influencerId
     * @param influencerGroupId
     * @param {number} companyId
     * @returns {Observable<any>}
     */
    GroupService.prototype.approveInfluencerInGroup = function (influencerIds, influencerGroupId, companyId) {
        var influencerToApprove = {
            companyId: companyId,
            influencers: influencerIds,
        };
        return this.put(apiEndpoints.approveInfluencers.replace(':groupId', influencerGroupId), influencerToApprove);
    };
    GroupService.prototype.getInfluencerGroups = function (companyId) {
        return this.get(apiEndpoints.getInfluencerGroupList, { selected_company_id: companyId }).map(function (res) { return res ? res.data : []; });
    };
    /**
     * this method is used to get the list of influencer who are belonged to existing group
     * @param groupId
     * @returns {Observable<any>}
     */
    GroupService.prototype.getListInfluencerBelongToGroup = function (groupId) {
        var apiEndpoint = apiEndpoints.getManualAddedInfluencerList.replace(':groupId', groupId);
        return this.get(apiEndpoint);
    };
    /**
   * this method is used to get monthly visit influencer
   * @returns {Observable<any>}
   */
    GroupService.prototype.getMonthlyVisitInfluencer = function (companyId, limit, offset) {
        var result = this.get(apiEndpoints.getMonthlyVisitInfluencer + ("?companyId=" + companyId + "&limit=" + limit + "&offsetId=" + offset));
        return result.map(function (res) { return res && res.data ? res.data : null; });
    };
    /**
     * this method is used to get pending influencer list
     * @returns {Observable<any>}
    */
    GroupService.prototype.getPendingInfluencerList = function (groupId, limit, lastSeenId) {
        var result = this.get(apiEndpoints.getPendingInfluencerList.replace(':groupId', groupId) + ("?limit=" + limit + "&lastSeenId=" + lastSeenId));
        return result.map(function (res) { return res && res.data ? res.data : null; });
    };
    GroupService.prototype.getInfluencerGroupSourceTypes = function () {
        var _this = this;
        return this.get(apiEndpoints.getInfluencerGroupSourceTypes).map(function (res) {
            if (res && res.data) {
                return res.data.map(function (source) { return ({
                    id: source.id,
                    name: _this.translate.instant("new_group_settings.auto_group_sources.sources." + source.label + ".value"),
                    value: _this.translate.instant("new_group_settings.auto_group_sources.sources." + source.label + ".dropdown"),
                }); });
            }
        });
    };
    GroupService.prototype.getInfluencerGroupFilterTypes = function () {
        var _this = this;
        return this.get(apiEndpoints.getInfluencerGroupFilterTypes).map(function (res) {
            if (res && res.data) {
                return res.data.map(function (filter) { return ({
                    id: filter.id,
                    name: _this.translate.instant("new_group_settings.auto_group_filters.filter." + filter.label + ".value"),
                    value: _this.translate.instant("new_group_settings.auto_group_filters.filter." + filter.label + ".dropdown"),
                }); });
            }
        });
    };
    return GroupService;
}(BackendHttpService));
export { GroupService };



// WEBPACK FOOTER //
// ./src/app/services/group-details/group.service.ts.pre-build-optimizer.js